import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33512f65&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=33512f65&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33512f65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33512f65')) {
      api.createRecord('33512f65', component.options)
    } else {
      api.reload('33512f65', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=33512f65&scoped=true", function () {
      api.rerender('33512f65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/board/label/IkLabelBase/index.vue"
export default component.exports